export default __webpack_public_path__ + "static/media/red-o-background.634c100c.svg";